<template>
  <div class="register-form">
    <!-- Logo -->
    <img src="../../public/image/logo.png" alt="Logo" class="logo" />

    <!-- 表单 -->
    <van-form @submit="onSubmit">
      <van-field
        v-model="phoneNo"
        label=""
        class="custom-style"
        placeholder="请输入手机号"
        :left-icon="require('@/assets/手机号@2x.png')"
        :rules="[
          { required: true, message: '请填写手机号码', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ]"
      />

      <van-field
        v-model="smsCode"
        label=""
        placeholder="请输入验证码"
        :left-icon="require('@/assets/验证 验证码@2x.png')"
        right-icon="code"
        :rules="[{ required: true, message: '请填写验证码', trigger: 'blur' }]"
      >
        <template #right-icon>
          <van-button
            size="mini"
            type=""
            @click.stop="getsmsCode"
            :disabled="counting || !isValidphoneNo"
            >{{ buttonText }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="password"
        :type="passwordtype"
        label=""
        placeholder="请输入 6-18 位新密码"
        :left-icon="require('@/assets/密码@2x.png')"
        right-icon="eye-o"
        :rules="[
          { required: true, message: '请填写密码', trigger: 'blur' },
          {
            min: 6,
            max: 18,
            message: '密码长度应在 6 到 18 个字符之间',
            trigger: 'blur',
          },
        ]"
      >
        <template #right-icon>
          <van-icon
            :name="passwordVisible ? 'eye-o' : 'closed-eye'"
            @click="togglePasswordVisibility"
          />
        </template>
      </van-field>
      <van-field
        v-model="conPassword"
        :type="conPasswordtype"
        label=""
        placeholder="请再次输入密码"
        :left-icon="require('@/assets/密码@2x.png')"
        right-icon="closed-eye"
        :rules="[
          {
            validator: validateconPassword,
            message: '两次输入的密码不一致',
            trigger: 'blur',
          },
        ]"
      >
        <template #right-icon>
          <van-icon
            :name="confirmPasswordVisible ? 'eye-o' : 'closed-eye'"
            @click="toggleConfirmPasswordVisibility"
          />
        </template>
      </van-field>
      <!-- 提交按钮 -->
      <div class="submit-button">
        <van-button round block type="info" native-type="submit"
          >立即注册</van-button
        >
      </div>
    </van-form>

    <!-- 用户协议 -->
    <div class="agreement">
      <van-checkbox
        v-model="agreeToTerms"
        icon-size="14px"
        checked-color="#EC682E"
        style="margin-left: 35px"
      >
        <span
          >我已阅读并同意
          <span class="tips">
            <a href="https://tdasvr.yunpinvip.com/priva">《隐私协议》</a>
            <a href="https://tdasvr.yunpinvip.com/serv">《服务协议》</a>
          </span>
        </span>
      </van-checkbox>
    </div>
    <div class="minibtn">
      <van-button size="small" @click="appdown">Android版下载</van-button>
      <van-button size="small" @click="appdowniphone">iPhone版下载</van-button>
    </div>
    <!-- 弹窗 -->
    <van-dialog
      v-model="show"
      title="<img src='@/assets/check.png' /> 注册成功 <img src='@/assets/check.png' />"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <!-- 标题前的Icon -->
      <template #title>
        <img src="@/assets/装饰-左@2x.png" alt="Before Image" />
        <span style="margin: 20px">注册成功</span>
        <img src="@/assets/装饰-右@2x.png" alt="After Image" />
      </template>
      <div class="dialogbtn" style="display: inline-grid">
        <span class="diabtnSpan">恭喜您，注册成功</span>
        <van-button :icon="require('@/assets/安卓@2x.png')" @click="appdown"
          >Android版下载</van-button
        >
        <van-button
          :icon="require('@/assets/苹果logo@2x.png')"
          @click="appdowniphone"
          >iPhone版下载</van-button
        >
      </div>
    </van-dialog>
    <!-- 遮罩层组件 -->
    <Overlay :show="isOverlayVisible" @close="isOverlayVisible = false" />
  </div>
</template>
<script>
import { registerUser, getsmsCode } from "@/api/auth";
import Overlay from "./Overlay.vue";
import axios from "axios";
export default {
  components: {
    Overlay,
  },
  data() {
    return {
      phoneNo: "",
      smsCode: "",
      password: "",
      conPassword: "",
      agreeToTerms: false,
      counting: false,
      countdown: 60,
      timer: null,
      smsSig: "",
      show: false,
      passwordVisible: false,
      confirmPasswordVisible: false,
      inviteCode: "",
      imageSrc: require("@/assets/logo.png"),
      isOverlayVisible: false,
    };
  },
  mounted() {
    const searchParams = new URLSearchParams(window.location.search);
    const user = searchParams.get("invite_code");
    this.inviteCode = user;
    this.checkIfWeChat();
  },
  computed: {
    buttonText() {
      return this.counting ? `重新获取(${this.countdown}s)` : "获取验证码";
    },
    isValidphoneNo() {
      return /^1[3-9]\d{9}$/.test(this.phoneNo);
    },
    passwordtype() {
      return this.passwordVisible ? "text" : "password";
    },
    conPasswordtype() {
      return this.confirmPasswordVisible ? "text" : "password";
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    },
    async onSubmit(values) {
      // 表单提交
      console.log("Form submitted:", values);
      if (!this.agreeToTerms) {
        this.$toast("请阅读并同意用户协议");
        return;
      }
      if (!this.inviteCode || this.inviteCode == "") {
        this.$dialog
          .alert({
            message: "请重新扫码",
            showConfirmButton: false,
          })
          .then(() => {});
      } else {
        try {
          const response = await registerUser({
            phoneNo: this.phoneNo,
            smsCode: this.smsCode,
            password: this.password,
            smsSig: this.smsSig,
            conPassword: this.conPassword,
            inviteCode: this.inviteCode,
          });
          // this.$toast('注册成功');
          if (response.code == 0) {
            this.show = true;
          } else {
            this.$toast(response.msg);
          }

          // console.log('注册成功:', response);
        } catch (error) {
          this.$toast("注册失败，请稍后再试");
          console.error("注册失败:", error);
        }
      }
    },
    getsmsCode() {
      console.log(this.inviteCode);

      if (this.counting) return;
      this.counting = true;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.resetCountdown();
        }
      }, 1000);
      // 发送请求获取验证码
      getsmsCode(this.phoneNo)
        .then((response) => {
          this.$toast("验证码已发送");
          console.log("验证码已发送:", response);
          this.smsSig = response.data.data.sig;
        })
        .catch((error) => {
          this.$toast("验证码发送失败，请稍后再试");
          console.error("验证码发送失败:", error);
          this.resetCountdown();
        });
    },
    validateconPassword(value) {
      return value === this.password;
    },
    resetCountdown() {
      clearInterval(this.timer);
      this.counting = false;
      this.countdown = 60;
    },
    appdowniphone() {
      // const url = 'https://testflight.apple.com/join/vEaVJBKW';
      // const url = 'https://apps.apple.com/app/id6736727448'

      // 检测是否为微信内置浏览器
      // 检测是否为微信内置浏览器
      if (this.isWeChat) {
        this.isOverlayVisible = true;
		this.show = false;
      } else {
        window.location.href = "https://apps.apple.com/app/id6736727448";
      }
    },

    checkIfWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWeChat = /micromessenger/.test(ua);
    },

    async appdown() {
      const userAgent = navigator.userAgent.toLowerCase();

      // 定义各应用市场的URI
      const appStoreUrls = {
        android: `https://fenfa1.kebei.net/a/Jj7gnX`,
        ios: `https://testflight.apple.com/join/vEaVJBKW`,
      };
      // 默认跳转地址
      const defaultUrl = "https://fenfa1.kebei.net/a/Jj7gnX";

      // 检测是否为iOS设备
      const isIOS = /iPhone|iphone|iPad|iPod/.test(userAgent);

      // 检测是否为Android设备
      const isAndroid = /android/.test(userAgent);
      // 根据设备类型确定跳转URL
      let appStoreUrl = defaultUrl;
      if (isIOS) {
        appStoreUrl = appStoreUrls.ios;
      } else if (isAndroid) {
        appStoreUrl = appStoreUrls.android;
      }

      try {
        const response = await axios.head(appStoreUrl, { timeout: 5000 });
        if (response.status === 200) {
          window.location.href = appStoreUrl;
        } else {
          window.location.href = defaultUrl;
        }
      } catch (error) {
        console.error("URL检查失败", error);
        window.location.href = defaultUrl;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
.register-form {
}

.logo {
  width: 74px;
  margin-bottom: 30px;
}

.agreement {
  margin-top: 20px;
  margin-bottom: 30px;
  color: #999;
}

::v-deep .van-cell {
  /* height: 50px; */
  background-color: #fff;
  color: #b5b5b5;
  font-size: 13px;
  margin-bottom: 10px;
  border-radius: 25px;
}

.van-button--mini {
  height: 24px;
  font-size: 13px;
  color: #ec672e;
  border: none;
  background: none;
}

.van-button--normal {
  padding: 0 15px;
  font-size: 14px;
  background: #ec682e;
  border: none;
  color: #fff;
  font-weight: bold;
  margin-top: 45px;
}

.submit-button {
  margin-top: -20px !important;
}

.agreement span {
  color: #333333;
  font-size: 11px;
}

.tips a {
  color: #ec672e !important;
}

::v-deep .van-icon-eye-o:before {
  content: "\e6b3";
  color: #ec672e;
}

::v-deep .van-icon-closed-eye:before {
  content: "\e691";
  color: #ec672e;
}

::v-deep .van-field__left-icon {
  margin-right: 4px;
  margin-top: 8px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.dialogbtn {
  margin-bottom: 30px;
}
.van-dialog {
  width: 270px;
}
.dialogbtn .diabtnSpan {
  color: #666666;
  font-size: 13px;
  margin-top: 20px;
  margin-bottom: 0px;
}
::v-deep .dialogbtn .van-button--normal {
  margin-top: 20px !important;
  background: linear-gradient(to right, #af3a24, #ffaa99);
  border-radius: 40px;
  font-size: 16px;
  font-weight: normal;
  height: 45px;
  width: 180px;
}
::v-deep .van-dialog__header {
  color: #fff;
  background: linear-gradient(to right, #af3a24, #ffaa99);
  font-size: 18px;
  padding-bottom: 15px;
  font-weight: bold;
}
.minibtn {
  margin-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
::v-deep .minibtn .van-button--small {
  /* background: #ec682e1f; */
  border: 1px solid #dba78a94;
  border-radius: 50px;
  color: #ec682e;
  font-size: 11px;
  height: 35px;
  width: 130px;
}
::v-deep .van-field__control {
  line-height: 32px;
}
/* 遮罩层基本样式 */
.overlay {
  position: fixed; /* 固定定位，使其相对于视口定位 */
  top: 0;
  left: 0;
  width: 100%; /* 宽度为100%，覆盖整个屏幕宽度 */
  height: 100%; /* 高度为100%，覆盖整个屏幕高度 */
  background-color: rgba(0, 0, 0, 0.5); /* 半透明的黑色背景 */
  z-index: 500; /* 确保遮罩层位于其他元素之上 */
  display: flex; /* 使用Flexbox布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  text-align: center; /* 文本居中 */
}

/* 遮罩层内容样式 */
.overlay-content {
  color: #fff; /* 文字颜色为白色 */
  font-size: 16px; /* 文字大小 */
  line-height: 1.5; /* 行高 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  background-color: rgba(0, 0, 0, 0.3); /* 背景颜色稍微加深 */
  max-width: 90%; /* 最大宽度限制 */
}

/* 遮罩层中的按钮样式 */
.overlay-content button {
  margin-top: 20px; /* 上外边距 */
  padding: 10px 20px; /* 内边距 */
  font-size: 16px; /* 字体大小 */
  color: #fff; /* 文字颜色 */
  background-color: #007bff; /* 背景颜色 */
  border: none; /* 无边框 */
  border-radius: 4px; /* 圆角 */
  cursor: pointer; /* 鼠标指针变为手形 */
}

/* 遮罩层中的按钮悬停效果 */
.overlay-content button:hover {
  background-color: #0056b3; /* 悬停时背景颜色变化 */
}
</style>
